import { IKImage } from 'imagekitio-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { editPricingBanner } from '../../redux/actions/userActivity';
import { useNavigate } from 'react-router-dom';
import { getLeads } from '../../redux/actions/userSubscription';

export default function PricingBanner({deviceInfo}) {

    const dispatch = useDispatch()
    const pricing_banner = useSelector(store => store?.userActivity?.pricing_banner)
    const user_id = useSelector(store => store?.profileDetails?.id)
    const role_type = useSelector(store => store?.userSubscription?.role_type)
    const navigate = useNavigate()
    if (!deviceInfo) {
        return null;
      }


    return (
        (!pricing_banner && <>
            <div
                className='text-white z-[999] py-1 mx-auto w-[100%]  lg:hidden shadow-lg fixed flex justify-around items-center px-3 bottom-0 left-0 right-0'
                style={{ 'z-index': '999 !important', background: 'linear-gradient(104.3deg, #040B23 20.51%, #040D2E 45.4%, #081338 57.55%, #030A23 86.32%)' }}
            >
                <div className='ml-2 mr-4'>
                    <FontAwesomeIcon icon={faTimes} size="lg" className='cursor-pointer' onClick={() => dispatch(editPricingBanner(true))} />
                </div>
                <div className='text-xs mr-1 whitespace-nowrap'>
                    For Best learning Exprience
                </div>
                {deviceInfo?.is_android === true && <div className="flex justify-center items-center cursor-pointer h-10">
                    <div onClick={() => window.open("https://play.google.com/store/apps/details?id=com.learntube", "_blank", 'noopener,noreferrer')}>
                        <img
                            urlEndpoint="https://assets.learntube.ai/files/"
                            src={"https://assets.learntube.ai/files/banner/googleplayButton.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1660911650301"}
                            transformation={[{
                                "height": "110",
                                "width": "110",
                            }]}
                            className="w-24 h-auto ml-1"
                        />
                    </div>
                </div> }
                <div className="flex justify-center items-center cursor-pointer ml-3">
                    <button className='text-black whitespace-nowrap px-1 rounded-lg text-[10px] font-semibold py-2' style={{ background: 'linear-gradient(90deg, #FFF2B1 0%, #FDDC32 94.91%)' }} onClick={() => {
                        dispatch(getLeads({
                            user_id: user_id ? user_id : 0,
                            user_plan: role_type ? role_type : 'basic',
                            product_id: 3,
                            product_name: 'LearnTubeX',
                            product_type: 'subscription',
                            is_visit: false,
                        }
                        ))
                        navigate("/pricing")
                    }}>Upgrade Now</button>
                </div>
            </div>
            <div
                className='text-white px-2 font-bold z-[10000000000000] mx-auto w-[100%] hidden lg:flex justify-center md:items-center shadow-lg fixed bottom-0 left-0 right-0 rounded  p-1'
                style={{ 'z-index': '1000000 !important', background: 'linear-gradient(104.3deg, #040B23 20.51%, #040D2E 45.4%, #081338 57.55%, #030A23 86.32%)' }}
            >
                
                <div className='flex justify-center text-base items-center'>
                    Get<span className='text-[#FCE468]'>&nbsp;Unlimited Certification</span>, Live Master Classes & <span className='text-[#FCE468]'>&nbsp;Placement Support&nbsp;</span>with LearnTubeX
                    <img
                        urlEndpoint="https://assets.learntube.ai/files/"
                        src={"https://assets.learntube.ai/files/banner/bannerImg.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1660911650046"}
                        transformation={[{
                            "height": "110",
                            "width": "110",
                        }]}
                        className="w-16 h-12 ml-10 scale-110"
                    />
                </div>
                <div className="flex justify-center items-center cursor-pointer ml-3">
                    <button className='text-black px-3 rounded-lg py-2 text-sm font-semibold' style={{ background: 'linear-gradient(90deg, #FFF2B1 0%, #FDDC32 94.91%)' }} onClick={() => {
                        dispatch(getLeads({
                            user_id: user_id ? user_id : 0,
                            user_plan: role_type ? role_type : 'basic',
                            product_id: 3,
                            product_name: 'LearnTubeX',
                            product_type: 'subscription',
                            is_visit: false,
                        }
                        ))
                        navigate("/pricing")
                    }}>Upgrade Now</button>
                    {/* {deviceInfo?.is_android === true && <div onClick={() => {
                        window.open("https://play.google.com/store/apps/details?id=com.learntube", "_blank", 'noopener,noreferrer')
                    }}>
                        <img
                            urlEndpoint="https://assets.learntube.ai/files/"
                            src={"https://assets.learntube.ai/files/banner/googleplayButton.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1660911650301"}
                            transformation={[{
                                "height": "110",
                                "width": "110",
                            }]}
                            className="h-10 ml-4"
                        />
                    </div>} */}
                </div>
                <div className='ml-5 mr-8 absolute right-0'>
                    <FontAwesomeIcon icon={faTimes} size="lg" className='cursor-pointer' onClick={() => dispatch(editPricingBanner(true))} />
                </div>
            </div>
        </>)
    )
}

